import { connect } from 'react-redux'
import { isRoles } from 'redux/actions'
import AccountPageWrapper from 'pages/account/AccountPageWrapper'

const mapStateToProps = (state) => ({
  userIs: (props) => isRoles(state, props)
})

export default connect(mapStateToProps, null)(AccountPageWrapper)
